module.exports = __webpack_public_path__ + "63b987225bb9f8e0b9c8821b474d365b.svg";